/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterTypeConstants } from './FilterTypeConstants';
import {
    FilterTypeConstantsFromJSON,
    FilterTypeConstantsFromJSONTyped,
    FilterTypeConstantsToJSON,
} from './FilterTypeConstants';
import type { Operator } from './Operator';
import {
    OperatorFromJSON,
    OperatorFromJSONTyped,
    OperatorToJSON,
} from './Operator';

/**
 * 
 * @export
 * @interface PropertyOperatorMapping
 */
export interface PropertyOperatorMapping {
    /**
     * 
     * @type {Array<Operator>}
     * @memberof PropertyOperatorMapping
     */
    filterOperators: Array<Operator>;
    /**
     * 
     * @type {FilterTypeConstants}
     * @memberof PropertyOperatorMapping
     */
    filterType?: FilterTypeConstants;
    /**
     * 
     * @type {string}
     * @memberof PropertyOperatorMapping
     */
    propertyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyOperatorMapping
     */
    autoCompletionSupported?: boolean;
}

/**
 * Check if a given object implements the PropertyOperatorMapping interface.
 */
export function instanceOfPropertyOperatorMapping(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filterOperators" in value;

    return isInstance;
}

export function PropertyOperatorMappingFromJSON(json: any): PropertyOperatorMapping {
    return PropertyOperatorMappingFromJSONTyped(json, false);
}

export function PropertyOperatorMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOperatorMapping {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filterOperators': ((json['filterOperators'] as Array<any>).map(OperatorFromJSON)),
        'filterType': !exists(json, 'filterType') ? undefined : FilterTypeConstantsFromJSON(json['filterType']),
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'autoCompletionSupported': !exists(json, 'autoCompletionSupported') ? undefined : json['autoCompletionSupported'],
    };
}

export function PropertyOperatorMappingToJSON(value?: PropertyOperatorMapping | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filterOperators': ((value.filterOperators as Array<any>).map(OperatorToJSON)),
        'filterType': FilterTypeConstantsToJSON(value.filterType),
        'propertyId': value.propertyId,
        'autoCompletionSupported': value.autoCompletionSupported,
    };
}

